export default {
  API_URL: process.env.REACT_APP_API_URL,
  REDIRECT_URL: `${window.location.origin}/password-reset`,
  MAXIMUM_IMAGE_SIZE: 20000000, // 20 MB
  MINIMUM_AVATAR_WIDTH: 720,
  MINIMUM_AVATAR_HEIGHT: 720,
  MINIMUM_COVER_WIDTH: 1200,
  MINIMUM_COVER_HEIGHT: 900,
};
